<!--
  ~ Copyright (c) 1999 - 2020 Accorto, Inc. - All rights reserved.
  -->

<div [class.slds-text-color_error]="isError"
     [class.slds-text-color_success]="isSuccess"
     [id]="id"
     class="status-line">{{status}}</div>
